export const EXAMPLE_LANGUAGES = [
    {code:'en-IN',label:'English (India)'},
    {code:'ml-IN',label:'Malayalam · മലയാളം'},
    {code:'hi-IN',label:'Hindi · हिन्दी'},
    {code:'ta-IN',label:'Tamil · தமிழ்'},
    {code:'te-IN',label:'Telugu · తెలుగు'},
    {code:'kn-IN',label:'Kannada · ಕನ್ನಡ'},
    {code:'ar-SA',label:'Arabic · العربية'},
    {code:'en-GB',label:'English (UK)'},
    {code:'en-US',label:'English (US)'},
];
export const exampleLanguage = value => EXAMPLE_LANGUAGES.some(item=>item.code===value)?value:'en-IN';
const storageKey='instil-lecture-example-language';
export function savedExampleLanguage(){try{return exampleLanguage(localStorage.getItem(storageKey));}catch{return 'en-IN';}}
export function rememberExampleLanguage(value){try{localStorage.setItem(storageKey,exampleLanguage(value));}catch{}}
